// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"030abcac","970":"ec6c1027"}[chunkId] + ".chunk.js";
};